import { IRouteProps } from 'IRoute'

import permissions from 'commons/constants/permissions'
import { List, CreateOrUpdate } from 'pages/Users'

const route:IRouteProps[] = [
  {
    path: '/users',
    component: List,
    roles: [permissions.USERS_ACCESS]
  },
  {
    path: '/users/create/',
    component: CreateOrUpdate,
    roles: [permissions.USERS_ACCESS]
  },
  {
    path: '/users/edit/:id',
    component: CreateOrUpdate,
    roles: [permissions.USERS_ACCESS]
  },
  {
    path: '/users/:id',
    component: CreateOrUpdate,
    roles: [permissions.USERS_ACCESS]
  }
]

export default route
